import React from 'react'

const SkillsPort = ({skillsData}) => {
  return (
    <div className="row  overflow-hidden mainDropFilter  my-5" id="Skills">
    <div className=" col-12">
      <h1 className=" text-center">
        <span
          className="pb-2"
          data-aos-duration="1000"
          data-aos="fade-right"
        >
          Skills
        </span>
      </h1>
      <section className="skills-section">
        <div className="skills-container">
          {skillsData.map((skill) => (
            <div
              className="skill-item"
              key={skill.id}
              data-aos-duration="1000"
              data-aos="flip-left"
            >
              <h3>{skill.name}</h3>
              <p>{skill.level}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  </div>
  )
}

export default SkillsPort
